module.exports = __webpack_public_path__ + "img/sakib.84887c19.jpg";